import { useCallback, useEffect, useState } from "react";
import { type AxiosError } from "axios";
import { axiosPost } from "@root/shared/utils/axiosForRails";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

type CassetteProps = {
  informationSource: string;
  clientName: string;
  businessTypeName: string;
  employmentName: string;
  salaryTypeName: string;
  salaryMin: number;
  salaryMax: number;
  workPlaceAddress: string;
  workDescription: string;
  detailUrl: string;
};

type ResponseProps = {
  cassettes: CassetteProps[];
};

type UseHelloWorkCassettesParams = {
  url: string;
  params: string[];
};

export const useHelloWorkCassettes = ({
  url,
  params,
}: UseHelloWorkCassettesParams): {
  helloWorkRawWorks: CassetteProps[];
} => {
  const [worksData, setWorksData] = useState<CassetteProps[]>([]);

  const fetchWorksData = useCallback(async () => {
    if (!url || params.length === 0) {
      setWorksData((prev) => (prev.length ? [] : prev));
      return;
    }
    // NOTE: axiosPost は名前は POST 用だが、GET も利用できる共通インスタンス
    //       API 呼び出し用 hooks を一本化する方針のため、現状はこの形にしている
    //       今後整理時に命名や分離をリファクタリング予定です
    try {
      const res = await axiosPost.get<ResponseProps>(url, {
        params: { hw_work_ids: params },
        paramsSerializer: { indexes: false },
      });
      setWorksData(res.data.cassettes ?? []);
    } catch (e) {
      const error = e as AxiosError;
      sendErrorLog(
        new Error(error.message || "ハローワーク求人カセットのデータを取得できませんでした"),
      );
    }
  }, [url, params]);

  useEffect(() => {
    fetchWorksData();
  }, [fetchWorksData]);

  return { helloWorkRawWorks: worksData };
};
